<template>
  <div class="goodslist" id="goodslist">
    <div class="header">
      <!--&lt;!&ndash;头部导航&ndash;&gt;-->
      <!--<van-nav-bar title="商品列表" left-arrow @click-left="goBack" @click-right="">-->
        <!--<van-icon slot="right" class="iconfont icon-fenlei2" style="font-size: 20px" @click="popupPlay"></van-icon>-->
      <!--</van-nav-bar>-->
      <!--搜索框-->
      <van-row style="background: white;">
        <!--<van-col span="8"><img style="margin-top: 5px" src="/static/images/logo.png" alt="百年人寿"></van-col>-->
        <van-col span="20">
          <form  class="seachbox" action="/">
            <van-search background="#fff"  v-model="search_keywords"  placeholder="请输入商品名称"  @search="onSearch"  style="background: #fff"/>
          </form>
        </van-col>
        <van-col style="background: #fff;height: 42px;text-align: center;line-height: 42px" span="4">
            <i  class="iconfont icon-fenlei2" style="font-size: 20px;" @click="popupPlay"></i>
        </van-col>
      </van-row>
      <!--<form class="seachbox" action="/">-->
        <!--<van-search placeholder="请输入商品名称" v-model="search_keywords" show-action @search="onSearch" @cancel="" style="background: #fff">-->
          <!--<div slot="action" class="searchbtn" @click=" ">搜索</div>-->
        <!--</van-search>-->
      <!--</form>-->
      <!--排序-->
      <van-tabbar class="sort">
        <div data-v-5348dbc4="" class="van-tabbar-item" @click="sortPlay(0)">
          <div class="van-tabbar-item__icon"></div>
          <div class="van-tabbar-item__text" :class="this.type==0 ? 'theme-col':''">默认</div>
        </div>
        <div data-v-5348dbc4="" class="van-tabbar-item" @click="sortPlay(3)">
          <div class="van-tabbar-item__icon"></div>
          <div class="van-tabbar-item__text" :class="this.type==3 ? 'theme-col':''">兑换量</div>
        </div>
        <div data-v-5348dbc4="" class="van-tabbar-item" @click="sortPlay(2)">
          <div class="van-tabbar-item__icon"></div>
          <div class="van-tabbar-item__text">
            积分
            <div class="infotop" :class="this.type==2&&this.sort == 0 ? 'theme-col':''"><i class="iconfont icon-shang"></i></div>
            <div class="infobottom" :class="this.type==2&&this.sort == 1 ? 'theme-col':''"><i class="iconfont icon-xia"></i></div>
          </div>
        </div>
        <div data-v-5348dbc4="" class="van-tabbar-item" @click="sortPlay(1)">
          <div class="van-tabbar-item__icon"></div>
          <div class="van-tabbar-item__text">
            时间
            <div class="infotop" :class="this.type==1&&this.sort == 0 ? 'theme-col':''"><i class="iconfont icon-shang"></i></div>
            <div class="infobottom" :class="this.type==1&&this.sort == 1 ? 'theme-col':''"><i class="iconfont icon-xia"></i></div>
          </div>
        </div>
        <div class="van-tabbar-item">
          <div class="van-tabbar-item__icon"></div>
          <div class="van-tabbar-item__text">
            <van-collapse v-model="activeName" accordion class="brandbox">
              <van-collapse-item title="筛选" name="1">
                <!--<van-cell-group>-->
                  <!--<div class="mui-navigate-right">-->
                    <!--<van-cell class="title">品牌</van-cell>-->
                  <!--</div>-->
                  <!--<van-row gutter="20">-->
                    <!--<van-col span="8" v-for="items in brandDatas" :key="items.id">-->
                      <!--<div :class="{'theme-col theme-bd':brand_id == items.id}" @click="brandPlay(items.id)">{{ items.name }}</div>-->
                    <!--</van-col>-->
                    <!--<van-col span="8">-->
                      <!--<div :class="{'theme-col theme-bd':brand_id == ''}" @click="brandPlay('')">不限</div>-->
                    <!--</van-col>-->
                  <!--</van-row>-->
                <!--</van-cell-group>-->
                <van-cell-group>
                  <div class="mui-navigate-right">
                    <van-cell class="title">积分区间</van-cell>
                  </div>
                  <van-row gutter="20">
                    <van-col span="12" v-for="(items,index) in jfSectionDatas" :key="items.id">
                      <div :class="{'theme-col theme-bd':items.point_min == point_min}" @click="jfSectionPlay(items.id)">{{ items.point_min }}{{ items.id == 5?'':'-' }}{{ items.point_max }}{{ items.id == 5?'不限':'积分' }}{{ items.id == 4?'以上':'' }}</div>
                    </van-col>
                  </van-row>
                  <div class="bottonCont">
                  	<van-button class="choiceBotton reset" size="normal" @click="screenPlay(false)">重置</van-button>
                  	<van-button class="choiceBotton sure theme-bd theme-bg" size="normal" @click="screenPlay(true)" >确认</van-button>
                  </div>

                </van-cell-group>
              </van-collapse-item>
            </van-collapse>
          </div>
        </div>
      </van-tabbar>
    </div>
    <!--侧滑菜单-->
    <van-popup v-model="popupshow" position="right" :overlay="true" class="popupleft">
      <van-collapse v-model="activeClass" accordion>
        <div class="van-collapse-item" @click="catAll()">
          <div class="goodsListitle van-cell van-cell--clickable van-hairline van-collapse-item__title">
            <div style="background:#eff3f6!important;" class="van-cell__value van-cell__value--alone">
              <div style="background: #fff" class="text-cent ft3"><i class="van-icon van-icon-arrow van-nav-bar__arrow popLeft"></i>全部商品</div>
            </div>
          </div>
        </div>
        <van-collapse-item v-for="(items,index) in classesdatas"  :name="index" :key="items.id">
          <div slot="title" @click="catidPlay(items.id)" class="text-cent"><!--<van-icon :class="items.img"/>-->{{ items.name }}</div>
          <!--二级分类-->
          <!--<ul>-->
            <!--<li v-for="item in items.value" @click="catidPlay(item.id)" :key="item.id" class="text-cent">&lt;!&ndash;<van-icon :class="item.img"/>&ndash;&gt;{{ item.name }}</li>-->
          <!--</ul>-->
        </van-collapse-item>
      </van-collapse>
    </van-popup>
    <!--主体-->
    <div class="conter">
      <!--商品列表-->
      <div class="nodata text-cent" v-if="finished && datas == ''">
        <P class="imgbox">
          <img src="/static/images/nodataimg6.png"/>
        </P>
        <p class="text">暂无商品~</p>
      </div>
      <van-list style="padding: 10px 10px 0 10px" v-model="loading" :finished="finished" @load="getDatas">
        <van-cell style="padding: 0;">
          <van-col span="12" v-for="(items,index) in datas" :key="index" >
            <router-link  :to="{path:'/goodslist/goods',query:{id:items.id}}">
              <!--<img v-lazy="items.product_img"/>-->
              <img style="height: 40vw" :src="items.product_img" onerror="src='/static/errorimg1.png'"/>
              <div>
                <p  class="tagbox">
                  <!--<span class="theme-bg theme-bd radius" v-if="items.is_new == 1">新品</span>-->
                  <!--<span class="theme-bg theme-bd radius" v-if="items.is_hot == 1">热销</span>-->
                  <!--<span class="theme-bg theme-bd radius" v-if="items.is_rob == 1">限时</span>-->
                  <!--<span plain class="theme-col radius theme-bg jd" v-if="items.dummy == 3">京东</span>-->
                </p>
                <p style="height: 21px" class="ellipse product-name">{{ items.product_name }}</p>
                <p class="theme-col product-price">{{ items.points_price  }}</p>
              </div>
            </router-link>
          </van-col>
        </van-cell>
      </van-list>
      <div v-if="!loading && finished && datas != ''" class="nomore"><span>已经到底了</span></div>
    </div>
    <footer-nav></footer-nav>
  </div>
</template>

<script>
  import Password from "../user/personal/password";
  import FooterNav from '@/components/footernav'
  export default {
    components: {
        Password,
        FooterNav
    },
    name: "goodslist",
    props:['configData'],
    data () {
      return {
        brandDatas:'',//品牌数据
        jfSectionDatas:[
          {
            point_min:1,
            point_max:1000,
            id:0
          },
          {
            point_min:1001,
            point_max:2000,
            id:1
          },
          {
            point_min:2001,
            point_max:5000,
            id:2
          },
          {
            point_min:5001,
            point_max:10000,
            id:3
          },
          {
            point_min:10000,
            point_max:'',
            id:4
          },
          {
            point_min:'',
            point_max:'',
            id:5
          }

        ],//积分区间数据
        activeName: 1,
        datas:[],//商品数据
        classesdatas:[],//分类列表数据
        activeClass:'1',
        page:0,//页码
        classes:0,//分类
        type:0,//排序分类
        sort:0,//排序
        brand_id:'',//品牌
        point_min:'',//积分区间最小值
        point_max:'',//积分区间最大值
        search_keywords:'',//搜索关键词
        popupshow:false,//侧滑状态
        loading:false,//下拉加载状态
        finished:false,//下拉加载是否开启
        ajaxfrom:{},
        topOr:false,//是否隐藏到顶部
        fullHeight: document.documentElement.clientHeight,//屏幕的高度
      }
    },
    watch: {
      $route(to,form){
        if(to.name == 'GoodsList' && form.name == 'Home' && to.query != form.query){
          this.datas = [];
          this.page = 0;
          if(this.finished){
            this.finished = false
          }else{
            this.getDatas()
          }
        }
      },
    },
    methods: {
      catAll:function () {
        this.datas = [];
        this.page = 0;
        this.popupshow = false;
        this.getDatas();
        this.$router.push({path:'/goodslist'});
      },
      goBack: function () {
        this.$router.push({path:'/'});
      },
      popupPlay: function () {
        this.popupshow = true;
        if( this.classesdatas == '' ){
          this.getClassesdatas()
        }
      },
      // 获取数据
      getDatas: function () {
        var _this = this;
        setTimeout(() => {
          this.page++;
          var isUser = localStorage.getItem("BLHuser")
          this.ajaxfrom = this.$route.query;
          this.ajaxfrom.token = isUser;
          this.ajaxfrom.p = this.page;
          this.$api.get('WebApi/product/Product/index', this.ajaxfrom, res => {
            if( res.data.data.length == 0 ){
              _this.finished = true;
              _this.loading = false;
            }else{
              for (let i = 0; i < res.data.data.length; i++) {
                _this.datas.push(res.data.data[i]);
              }
              _this.loading = false;
            }
          })
        },50)
      },
      // 搜索关键词
      onSearch: function () {
        if( this.search_keywords != undefined && this.search_keywords != '' ){
          this.datas = [];
          this.page = 0;
          this.$router.push({path:'/goodslist',query:{'search_keywords':this.search_keywords}});
          if(this.finished){
            this.finished = false
          }else{
            this.loading = true;
            this.getDatas()
          }
        }else{
          this.$toast('请输入要搜索的商品');
        }
      },
      // 获取品牌信息
      getBrand: function () {
        this.$api.get('WebApi/Product/Product/getbrand', {classify_id:this.classes}, res => {
          this.brandDatas = res.data.data
        })
      },
      // 获取分类列表
      getClassesdatas: function () {
        this.$api.get('WebApi/product/Product/getCart', {classify_id:this.classes}, res => {
          this.classesdatas = res.data.data
        })
      },
      // 排序
      sortPlay: function (e) {
        this.datas = [];
        this.page = 0;
        this.type = e;
        this.sort==0?this.sort=1:this.sort=0;

        this.ajaxfrom.type = this.type
        this.ajaxfrom.sort = this.sort
        if(this.finished){
          this.finished = false
        }else{
          this.loading = true;
          this.getDatas()
        }
      },
      // 品牌搜索
      brandPlay: function (id) {
        this.brand_id = id;
      },
      // 积分搜索
      jfSectionPlay: function (id) {
        this.point_min = this.jfSectionDatas[id].point_min;
        this.point_max = this.jfSectionDatas[id].point_max;
      },
      //筛选
      screenPlay: function (re) {
        if( re ){
          this.activeName = 2
          this.datas = [];
          this.page = 0;

          this.ajaxfrom.brand_id = this.brand_id;
          this.ajaxfrom.point_min = this.point_min;
          this.ajaxfrom.point_max = this.point_max;
          console.log(this.ajaxfrom)
          this.$router.push({path:'/goodslist',query:{brand_id:this.ajaxfrom.brand_id,point_min:this.ajaxfrom.point_min,point_max:this.ajaxfrom.point_max}});
          if(this.finished){
            this.finished = false
          }else{
            this.loading = true;
            this.getDatas()
          }
          this.popupshow = false
        }else{
          this.brand_id = '';
          this.point_min = '';
          this.point_max = '';

          delete this.ajaxfrom.brand_id;
          delete this.ajaxfrom.point_min;
          delete this.ajaxfrom.point_max
        }
      },
      // 分类搜索
      catidPlay: function (e) {
        this.datas = [];
        this.page = 0;
        this.brand_id = '';
        this.point_min = '';
        this.point_max = '';
        this.search_keywords='';

        delete this.ajaxfrom.brand_id;
        delete this.ajaxfrom.point_min;
        delete this.ajaxfrom.point_max;
        delete this.ajaxfrom.search_keywords;

        this.classes = e;
        this.ajaxfrom.cat_id = this.classes
        this.popupshow = false;
        this.$router.push({path:'/goodslist',query:{cat_id:this.ajaxfrom.cat_id}});
        if(this.finished){
          this.finished = false
        }else{
          this.loading = true;
          this.getDatas()
        }
      },
    },
    mounted () {
      this.getBrand()
    },
    created () {
    },
    updated () {
    }
  }
</script>
<style lang="less">
  .goodslist{
    background:#eff3f6 ;
    .seachbox{
      .van-search__wrap{
        border-radius: 17px;
        background: #f2f2f2;
        border: none;
        .van-icon{
          color: #999!important;
        }
        input{
          background: #f2f2f2;
        }
      }
    }
    .van-list{
      background: #eff3f6;
      .van-col{
        vertical-align: top;
        float: none;
        display: inline-block;
      }
      img{
        margin-bottom: 5px;
      }
    }
    .conter{
      padding-top: 88px;
      padding-bottom: 55px;
    }
    .searchbtn{
      padding: 0 10px;
    }
    .sort{
      border-top: 1px solid #f2f2f2;
      border-bottom: 1px solid #f2f2f2;
      position: relative;
      height: auto;
      .van-tabbar-item__icon {
        display: none;
      }
      .van-tabbar-item{
        padding: 15px 0;
      }
      .van-tabbar-item__text{
        position: relative;
      }
      .infotop,.infobottom{
        background-color: inherit;
        color: #000;
        position: absolute;
        right: -20px;
        font-size: 14px;
      }
      .infotop .iconfont,.infobottom .iconfont{
        font-size: 15px;
      }
      .infotop{
        top: -6px;
      }
      .infobottom{
        bottom: -4px;
      }
      .brandbox{
        .van-cell:not(:last-child)::after{
          border-bottom-width: 0;
        }
        .van-cell{
          padding: 0;
          line-height: inherit;
          .van-icon{
            line-height: inherit;
            z-index: 2;
          }
        }
        .van-collapse-item__content{
          position: fixed;
          width: 100vw;
          left: 0;
          box-sizing: border-box;
          top: 50px;
          padding: 0;
          padding-top: 10px;
          border-bottom: 1px solid #ccc;
          .van-cell,.van-row{
            padding: 0px 15px;
          }
          .van-row{
            .van-col{
              text-align: center;
              margin:8px 0;
              div{
                font-size: 1.6rem;
                padding: 5px 0;
                border: 1px solid #bdbdbd;
                border-radius: 3px;
              }
            }
          }
        }
      }
    }
    .popupleft {
      height: 100%;
      width: 180px;
      overflow: scroll;
      .van-collapse-item__content{
        padding: 5px 0 5px 30px;
      }
      .van-cell__right-icon{
        position: absolute;
        right: 34px;
        height: 1.4rem;
        width: 1.4rem;
        text-align: center;
        line-height: 1.4rem;
        top: 14px;
        background-color: #999;
        border-radius: 50%;
      }
      .van-cell__right-icon::before{
        color: #fff;
      }
      .iconfont{
        margin-right: 5px;
        vertical-align: middle;
        font-size: 2rem;
      }
      li{
        padding: 5px 0;
      }
    }
    .van-popup--right{
      .van-collapse{
        width: 181px;
      }
    }
    .header{
      position: fixed;
      width: 100%;
      z-index: 9;
    }

    .popLeft.van-icon{
    	top: 2px;
    	left: -35px;
    }
    .bottonCont{
    	overflow: hidden;
    	position: relative;
    	top: 11px;
    }
    .choiceBotton.van-button{
    	width: 50%;
    	float: left;
    	border-radius:0!important;
    }
    .reset.van-button{
    	background: #f4f4f4;
    	border-color: #D2D2D2;
    	border-right:none ;
    }
    .van-collapse-item__content .text-cent{
    	position: relative;
    }
    .van-collapse-item__content .text-cent:after{
    	content: "";
    	position: absolute;
    	left: 15px;
    	height: 1px;
	    right: 0;
	    width:100%;
	    bottom: 0;
	    background-color: #e5e5e5;
	    -webkit-transform: scale(1,.5);
	    transform: scale(1,.5);
	    border-bottom-width: 1px;
    }
    .van-collapse-item__content .text-cent:last-child:after{
    	height: 0px;
    }
    .radius {
      padding: 0 5px 1px!important;
      -webkit-border-radius:10px 0;
      -moz-border-radius:10px 0;
      border-radius:10px 0 ;
    }
    .van-col--12 {
      width: 49%;
      background: #fff;
      border: 3px solid #fff;
    }
    .van-col--12:nth-child(2n){
      margin-left: 1%!important;
      margin-bottom: 2.5vw;
    }
    .van-col--12:nth-child(2n-1){
      margin-right: 1%!important;
      margin-bottom: 2.5vw;
    }
    .van-col--12:not(:last-child)::after {
      border-bottom-width: 0px;
    }
    .totop{
      width: 38px;
      height: 38px;
      border-radius: 50%;
      position: fixed;
      bottom:56px;
      right: 10px;
      background: #ddd;
      text-align: center;
    }
    .totop i{
      font-size: 22px;
      line-height: 38px;
      color: #fff!important;
    }
    .van-cell__right-icon{
      display: none;
    }

    .goodsListitle{
      border:0.5px solid #e5e5e5 ;
    }


  }

</style>



// WEBPACK FOOTER //
// src/pages/goods/index.vue